// JS Depedency
var jquery = require('jquery');

// Intialisation
window.$ = window.jQuery = jquery;
